module.exports = __webpack_public_path__ + "img/retail.1e791d47.svg";